import React, {useState} from "react";
import {Card, ListGroup} from 'react-bootstrap';

const AllTagsListPartial = ({items, tags, selectedSeries, selectedLevels, setSelectedTagsHandler}) => {

  const [selectedValues, setSelectedValues] = useState([]);
  
  const handleChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    if (isChecked) {
      setSelectedValues(prevSelectedValues => [...prevSelectedValues, value]);
      setSelectedTagsHandler(prevSelectedValues => [...prevSelectedValues, value]);
    } else {
      setSelectedValues(prevSelectedValues => prevSelectedValues.filter(item => item !== value));
      setSelectedTagsHandler(prevSelectedValues => prevSelectedValues.filter(item => item !== value));
    }
  }

 

  let response = items;
  if(selectedSeries.length > 0 && response != null){
    response = response.filter(item => {
      return item.series.some(seriesItem => {
        return selectedSeries.some(filterItem => filterItem.value === seriesItem.slug)
        && (selectedLevels.length === 0 || selectedLevels.some(filterItem => filterItem.value === seriesItem.age));
      });
    });
  }

  const extractedTempTags = response.flatMap(item => item.tags);
  const uniqueFilteredTags = [...new Set(extractedTempTags)];

  const sortTags = (a, b) => {
    return a.sort - b.sort;
  }

  return(
    <React.Fragment>
      <Card className="p-0">
        <Card.Header className="bg-violet text-white"><strong>Filtry</strong></Card.Header>
        <ListGroup className="list-group-flush">
          {tags.sort(sortTags).filter(value => uniqueFilteredTags.includes(value.slug)).map((value, key) => {
            const doesNotExistInUniqueTags = !uniqueFilteredTags.includes(value.slug);
            const cssClassName = doesNotExistInUniqueTags ? "list-item-disabled" : null;
            const isChecked = selectedValues.includes(value.slug);
            
            return(
              <ListGroup.Item className={cssClassName} key={key}><label><input disabled={doesNotExistInUniqueTags} checked={isChecked} type="checkbox" name={value.slug} value={value.slug} onChange={handleChange} /> {value.name}</label></ListGroup.Item>
            )
          })}
        </ListGroup>
      </Card>
    </React.Fragment>
  )

}
export default AllTagsListPartial;